/**
 * B1099 (Eric 2026-09-07) — Chargement partagé du gabarit commun.
 *
 * Les 7 appels de la barre latérale et de l'en-tête (badges, cloche,
 * organisations, modules de tags, budget LLM, état PROD, tâches de fond)
 * étaient rejoués à CHAQUE affichage de page, sur toutes les pages. Ils
 * passent maintenant par un unique `GET /api/layout/bootstrap`.
 *
 * Deux garde-fous, comme pour `apiCache` (B1085) : les composants montés
 * en même temps partagent la MÊME promesse (pas de rafale au boot), et
 * `refreshLayoutBootstrap()` force un nouvel appel après une mutation —
 * un cache qu'on ne peut pas vider est un bogue en attente.
 */
import axios from "axios";
import { API_BASE as API } from "./apiBase";

const TTL_MS = 20_000;
// Fenêtre de démarrage : tout consommateur qui charge ses données dans les
// 15 s suivant l'ouverture de la page passe par l'appel agrégé. Ce critère
// temporel remplace un drapeau « premier appel » par instance, qui laissait
// filer des appels en double (deux barres latérales bureau/mobile, doubles
// effets React en développement).
const BOOT_WINDOW_MS = 15_000;
const PAGE_LOADED_AT = Date.now();

export const isLayoutBootWindow = () => Date.now() - PAGE_LOADED_AT < BOOT_WINDOW_MS;

let entry = null; // { promise } | { value, at }

function buildUrl() {
  let factualSince = null;
  try {
    factualSince = localStorage.getItem("knoria_last_visited_factual_corrections");
  } catch { /* localStorage indisponible → badge en mode total */ }
  return factualSince
    ? `${API}/api/layout/bootstrap?factual_since=${encodeURIComponent(factualSince)}`
    : `${API}/api/layout/bootstrap`;
}

export function getLayoutBootstrap({ force = false } = {}) {
  if (!force && entry) {
    if (entry.promise) return entry.promise;
    if (Date.now() - entry.at < TTL_MS) return Promise.resolve(entry.value);
  }
  const promise = axios
    .get(buildUrl(), { withCredentials: true })
    .then((res) => {
      entry = { value: res.data, at: Date.now() };
      return res.data;
    })
    .catch((err) => {
      entry = null;
      throw err;
    });
  entry = { promise };
  return promise;
}

/** Force le prochain `getLayoutBootstrap()` à refaire l'appel. */
export function refreshLayoutBootstrap() {
  entry = null;
  return getLayoutBootstrap({ force: true });
}
